import React from 'react';
import { AuthProvider as OidcAuthProvider } from 'react-oidc-context';
import { oidcConfig, isDemoMode } from '../config/authConfig';

// Create a dummy OIDC config for demo mode to prevent context errors
const demoOidcConfig = {
  ...oidcConfig,
  automaticSilentRenew: false,
  // Use a dummy authority that won't actually be used
  authority: 'https://demo.example.com',
  client_id: 'demo',
  redirect_uri: window.location.origin,
  post_logout_redirect_uri: window.location.origin,
  // Disable all automatic auth flows
  loadUserInfo: false,
  automaticSilentRenew: false,
  monitorSession: false
};

export function AuthProvider({ children }) {
  const isDemo = isDemoMode();

  // Use demo config for demo mode, real config otherwise
  const config = isDemo ? demoOidcConfig : oidcConfig;

  const handleSigninCallback = () => {
    // Get the stored return URL or default to executive summary
    const returnUrl = sessionStorage.getItem('returnUrl') || '/mpm/executive-summary';
    sessionStorage.removeItem('returnUrl');

    // Redirect to the target page
    window.location.replace(returnUrl);
  };

  const handleError = (error) => {
    console.error('Auth error:', error);
    // You can add custom error handling here
    // For example, show a notification to the user
  };

  return (
    <OidcAuthProvider
      {...config}
      onSigninCallback={!isDemo ? handleSigninCallback : undefined}
      onRemoveUser={!isDemo ? () => {
        // Handle user removal (e.g., token expiry)
        console.log('User session ended');
      } : undefined}
      onAccessTokenExpiring={!isDemo ? () => {
        // Token is about to expire, silent renewal will be attempted
        console.log('Access token expiring, attempting renewal...');
      } : undefined}
      onAccessTokenExpired={!isDemo ? () => {
        // Token has expired
        console.log('Access token expired');
      } : undefined}
      onSignoutRedirect={!isDemo ? () => {
        // Clear any local state if needed
        console.log('Signing out...');
      } : undefined}
      skipSigninCallback={isDemo}
    >
      {children}
    </OidcAuthProvider>
  );
}